"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
// Packages

// Main Component
function SEO(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("html", {
    lang: props.lang
  }), props.title && /*#__PURE__*/_react.default.createElement("title", null, props.title), props.description && /*#__PURE__*/_react.default.createElement("meta", {
    name: "description",
    content: props.description
  }), (props.ogTitle || props.title) && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:title",
    content: props.ogTitle || props.title
  }), (props.ogDescription || props.description) && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:description",
    content: props.ogDescription || props.description
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:type",
    content: props.ogType
  }), props.slug && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:url",
    content: `${props.domain}/${props.slug === "index" ? "" : `${props.slug}/`}`
  }), props.ogImage !== null && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:image",
    content: props.ogImage
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:image:width",
    content: props.ogImageWidth
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:image:height",
    content: props.ogImageHeight
  })), props.canonicalSlug && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("link", {
    rel: "canonical",
    href: `${props.domain}/${props.canonicalSlug}/`
  })), props.hidden && /*#__PURE__*/_react.default.createElement("meta", {
    name: "robots",
    content: "none"
  }), props.children);
}
SEO.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SEO",
  "props": {
    "domain": {
      "defaultValue": {
        "value": "`https://www.atlanticbay.com`",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "hidden": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Should this page be hidden? (not indexed on Google)",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "lang": {
      "defaultValue": {
        "value": "\"en\"",
        "computed": false
      },
      "description": "Language of the page",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ogImage": {
      "defaultValue": {
        "value": "\"https://images.ctfassets.net/n1no4gieqp7s/5gUWAA0iI9RslGOWYft61q/8c29b1ab4c29f5374ad232ed92375100/AtlanticBay-OG.jpg\"",
        "computed": false
      },
      "description": "OG image of the page",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ogImageWidth": {
      "defaultValue": {
        "value": "`1200`",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ogImageHeight": {
      "defaultValue": {
        "value": "`628`",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ogType": {
      "defaultValue": {
        "value": "`website`",
        "computed": false
      },
      "description": "OG type of the page (website, article, etc)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "canonicalSlug": {
      "description": "If there is a duplicate version of this page\nand this is not the canonical version, include the canonicalSlug prop",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "slug": {
      "description": "Slug of the page",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "description": {
      "description": "Description of the page",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ogDescription": {
      "description": "OG description of the page\nIf OG description is the same as description, there is no need to add OG description prop",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "title": {
      "description": "Title of the page",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ogTitle": {
      "description": "OG Title of the page\nIf OG title is the same as title, there is no need to add OG title prop",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = SEO; // Prop Types
exports.default = _default;
SEO.propTypes = {
  /** If there is a duplicate version of this page
   * and this is not the canonical version, include the canonicalSlug prop
   */
  canonicalSlug: _propTypes.default.string,
  /** Slug of the page */
  slug: _propTypes.default.string,
  children: _propTypes.default.node,
  /** Description of the page */
  description: _propTypes.default.string,
  /** OG description of the page
   * If OG description is the same as description, there is no need to add OG description prop
   */
  ogDescription: _propTypes.default.string,
  /** OG image of the page */
  ogImage: _propTypes.default.string,
  ogImageWidth: _propTypes.default.string,
  ogImageHeight: _propTypes.default.string,
  /** Title of the page */
  title: _propTypes.default.string,
  /** OG Title of the page
   * If OG title is the same as title, there is no need to add OG title prop
   */
  ogTitle: _propTypes.default.string,
  /** OG type of the page (website, article, etc) */
  ogType: _propTypes.default.string,
  /** Should this page be hidden? (not indexed on Google) */
  hidden: _propTypes.default.bool,
  /** Language of the page */
  lang: _propTypes.default.string,
  domain: _propTypes.default.string
};
SEO.defaultProps = {
  domain: `https://www.atlanticbay.com`,
  hidden: false,
  lang: "en",
  ogImage: "https://images.ctfassets.net/n1no4gieqp7s/5gUWAA0iI9RslGOWYft61q/8c29b1ab4c29f5374ad232ed92375100/AtlanticBay-OG.jpg",
  ogImageWidth: `1200`,
  ogImageHeight: `628`,
  ogType: `website`
};